export default __webpack_public_path__ + "static/orangeloop-sviluppo-in-outsourcing-vantaggi-aziende-bcbc78d8f2c41c38f4d85e67f4c1e00a.png";